// // src/components/YearSelect.js
// import React from "react";

// const YearSelect = ({
//   selectedYear,
//   onChange,
//   yearsCount = 3, // how many years back to show
//   className = "col-sm-3", // wrapper class
// }) => {
//   const currentYear = new Date().getFullYear();
//   const years = Array.from({ length: yearsCount }, (_, i) => currentYear - i);

//   return (
//     <div className={className}>
//       <select
//         className="form-select"
//         value={selectedYear || ""}
//         onChange={onChange}
//       >
//         <option value="" disabled>
//           Select Year
//         </option>
//         {years.map((year) => (
//           <option key={year} value={year}>
//             {year}
//           </option>
//         ))}
//       </select>
//     </div>
//   );
// };

// export default YearSelect;
import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

const YearSelect = ({
  selectedYear,
  onChange,
  yearsCount = 5,
  className = "col-sm-6 col-lg-3",
  label = "Year",
  placeholder = "Select Year",
  disabled = false,
  error,
  helperText,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: yearsCount }, (_, i) => currentYear - i);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearchTerm("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (year) => {
    // Create synthetic event to match your existing onChange handler
    const syntheticEvent = {
      target: {
        name: "selectedYear",
        value: year,
      },
    };

    onChange(syntheticEvent);
    setIsOpen(false);
    setSearchTerm("");
  };

  const filteredYears = years.filter((year) =>
    year.toString().includes(searchTerm),
  );

  const displayValue = selectedYear || placeholder;

  return (
    <div className={className}>
      <div style={{ position: "relative", width: "100%" }} ref={dropdownRef}>
        {label && (
          <label
            style={{
              display: "block",
              fontSize: "0.875rem",
              fontWeight: 500,
              color: error ? "#ef4444" : "#374151",
              marginBottom: "6px",
              fontFamily: "Inter, sans-serif",
            }}
          >
            {label}
          </label>
        )}

        {/* Custom Select Button */}
        <button
          type="button"
          onClick={() => !disabled && setIsOpen(!isOpen)}
          disabled={disabled}
          style={{
            width: "100%",
            height: "38px",
            padding: "0 12px",
            border: error
              ? "1px solid #ef4444"
              : isOpen
                ? "1px solid #1F4D2C"
                : "1px solid #d1d5db",
            borderRadius: "8px",
            fontSize: "0.9rem",
            fontFamily: "Inter, sans-serif",
            backgroundColor: disabled ? "#f9fafb" : "#ffffff",
            cursor: disabled ? "not-allowed" : "pointer",
            textAlign: "left",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            transition: "all 0.2s ease",
            color: selectedYear ? "#374151" : "#9ca3af",
            boxShadow: isOpen
              ? error
                ? "0 0 0 3px rgba(239, 68, 68, 0.1)"
                : "0 0 0 3px rgba(31, 77, 44, 0.1)"
              : "none",
          }}
        >
          <span>{displayValue}</span>
          <i
            className="bi bi-calendar3"
            style={{
              fontSize: "1rem",
              color: disabled ? "#d1d5db" : "#6b7280",
            }}
          ></i>
        </button>

        {/* Custom Dropdown */}
        {isOpen && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 4px)",
              left: 0,
              right: 0,
              backgroundColor: "#ffffff",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              boxShadow:
                "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
              zIndex: 1000,
              maxHeight: "300px",
              overflow: "hidden",
              fontFamily: "Inter, sans-serif",
            }}
          >
            {/* Search Input */}
            {/* <div
              style={{
                padding: "8px 12px",
                borderBottom: "1px solid #f3f4f6",
                position: "sticky",
                top: 0,
                backgroundColor: "#ffffff",
                zIndex: 1,
              }}
            >
              <input
                type="text"
                placeholder="Search year..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  width: "100%",
                  padding: "6px 10px",
                  border: "1px solid #e5e7eb",
                  borderRadius: "6px",
                  fontSize: "0.85rem",
                  fontFamily: "Inter, sans-serif",
                  outline: "none",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#1F4D2C";
                  e.target.style.boxShadow = "0 0 0 2px rgba(31, 77, 44, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e5e7eb";
                  e.target.style.boxShadow = "none";
                }}
              />
            </div> */}

            {/* Options List */}
            <div
              style={{
                maxHeight: "240px",
                overflowY: "auto",
                padding: "4px",
              }}
            >
              {filteredYears.length > 0 ? (
                filteredYears.map((year) => {
                  const isSelected =
                    selectedYear === year || selectedYear === year.toString();

                  return (
                    <div
                      key={year}
                      onClick={() => handleSelect(year)}
                      style={{
                        padding: "10px 12px",
                        cursor: "pointer",
                        borderRadius: "6px",
                        fontSize: "0.9rem",
                        color: isSelected ? "#ffffff" : "#374151",
                        backgroundColor: isSelected ? "#1F4D2C" : "transparent",
                        fontWeight: isSelected ? 600 : 400,
                        transition: "all 0.15s ease",
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = "#f3f4f6";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = "transparent";
                        }
                      }}
                    >
                      {year}
                    </div>
                  );
                })
              ) : (
                <div
                  style={{
                    padding: "20px 12px",
                    textAlign: "center",
                    color: "#9ca3af",
                    fontSize: "0.85rem",
                  }}
                >
                  <i
                    className="bi bi-search"
                    style={{
                      fontSize: "1.5rem",
                      marginBottom: "8px",
                      display: "block",
                    }}
                  ></i>
                  <p className="mb-0">No years found</p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Helper Text */}
        {helperText && !error && (
          <small
            style={{
              display: "block",
              marginTop: "4px",
              color: "#6b7280",
              fontSize: "0.8rem",
              fontFamily: "Inter, sans-serif",
            }}
          >
            <i className="bi bi-info-circle me-1"></i>
            {helperText}
          </small>
        )}

        {/* Error Message */}
        {error && (
          <small
            style={{
              display: "block",
              marginTop: "4px",
              color: "#ef4444",
              fontSize: "0.8rem",
              fontFamily: "Inter, sans-serif",
            }}
          >
            <i className="bi bi-exclamation-circle me-1"></i>
            {error}
          </small>
        )}
      </div>
    </div>
  );
};

YearSelect.propTypes = {
  selectedYear: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  yearsCount: PropTypes.number,
  className: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  helperText: PropTypes.string,
};

export default YearSelect;
